<div [ngSwitch]="field?.appearance">
  <relation-radio *ngSwitchCase="'radio'" [field]="field" [formGroup]="formGroup"></relation-radio>
  <combobox-single *ngSwitchDefault [field]="field" [formGroup]="formGroup"></combobox-single>
</div>
